export default __webpack_public_path__ + "static/media/8923.de639d88.svg";